<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="loseDialog"
    :close-on-click-modal="false"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="130px"
    >
      <el-row :gutter="12">
        <el-col>
          <el-form-item label="学院名称：" prop="deptName">
            <el-input
              v-model="curdForm.deptName"
              placeholder="请输入学院名称"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="学院属性：" prop="unitAttr">
            <el-select
              v-model="curdForm.unitAttr"
              placeholder="请选择学院属性"
              style="width: 100%"
            >
              <el-option
                v-for="(item, i) in deptUnitAttr"
                :key="i"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item
            label="属性类别："
            prop="attrCategory"
            :rules="[{ required: true, message: '请选择属性类别' }]"
          >
            <el-select
              v-model="curdForm.attrCategory"
              placeholder="请选择属性类别"
              style="width: 100%"
            >
              <el-option
                v-for="(item, i) in deptAttrCategory"
                :key="i"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="联系电话：" prop="collegeMobile">
            <el-input
              v-model="curdForm.collegeMobile"
              placeholder="请输入联系电话"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="小程序客服电话：" prop="appletMobile">
            <el-input
              type="textarea"
              v-model="curdForm.appletMobile"
              placeholder="请输入小程序客服电话"
              maxlength="1000"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="学院简介：" prop="deptDesc">
            <el-input
              type="textarea"
              v-model="curdForm.deptDesc"
              placeholder="请输入学院简介"
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="小程序地市频道：" prop="localChannel">
            <el-input
              v-model="curdForm.localChannel"
              placeholder="请输入频道名称和链接地址，通过丨隔开"
              maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom('curdForm')" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import rulesFactory from "@/utils/rules";
import { deptAdd, deptEdit, findMostTopDept } from "@/api/dept";
import { getSysParamByTypes } from "@/api/sysParam";
import { getItem } from "@/utils/storage";
export default {
  components: { butn },
  data() {
    return {
      Bus,
      rules: {
        deptName: [
          rulesFactory.required("请填写学院名称"),
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        unitAttr: [rulesFactory.required("请填写学院属性")],
        attrCategory: [rulesFactory.required("请选择属性类别")],
      },
      curdTitle: "",
      CUFlag: false,
      Dflag: false,
      curdForm: {},
      props: {
        //树形
        label: "name",
        children: "children",
      },
      defaultCheckedKeys: [],
      command: function () {},
      parentName: "",
      deptUnitAttr: [],
      deptAttrCategory: [],
      parentId: "",
      organizeTypeList: [],
    };
  },
  created() {
    var _this = this;
    _this.getSysParamByTypes([
      "DEPT_UNIT_ATTR",
      "DEPT_ATTR_CATEGORY",
      "ORGANIZE_TYPE",
    ]);
    // 获取顶级部门uuid
    _this.findMostTopDept();
    Bus.$on("ReceiveMessage", function (item) {
      _this.$nextTick(() => {
        _this.curdTitle = item == "" ? "新增学院" : "编辑学院";
        _this.command = item == "" ? deptAdd : deptEdit;
        _this.CUFlag = true;
        _this.parentName = "";
        if (item) {
          item.deptName = item.name;
          item.parentId = item.pid;
          item.deptLevel = item.level;
        }
        _this.curdForm = item || {
          deptName: "",
          parentId: _this.parentId,
          deptLevel: 1,
          deptDesc: "",
          organizeType: _this.organizeTypeList[0].paramKey,
        };
        if (item === "123") {
          _this.CUFlag = false;
        }
      });
    });
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.deptUnitAttr = res.data["DEPT_UNIT_ATTR"];
        this.deptAttrCategory = res.data["DEPT_ATTR_CATEGORY"];
        this.organizeTypeList = res.data["ORGANIZE_TYPE"];
      });
    },
    findMostTopDept() {
      findMostTopDept().then((res) => {
        if (res && res.code == 0) {
          this.parentId = res.data.uuid;
        }
      });
    },
    createData() {
      this.$refs.curdForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.curdForm.uuid = this.curdForm.id || "";
          // 当前角色roleDeptId
          // this.curdForm.parentId = getItem("roleDeptId");
          this.curdForm.deptCode = 1;
          const params = Object.assign({}, this.curdForm);
          this.command(params).then((res) => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              Bus.$emit("reload");
              this.CUFlag = false;
            }
          });
        }
      });
    },
    closeFrom(curdForm) {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs[curdForm].resetFields();
    },
    loseDialog() {
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped></style>
